import React from "react";

// Types
import { Sponsor } from "../../types";

// Factories
import { InputFactory } from "../Factories/Input";

// Components
import { faTrashAlt } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IonNote, IonRouterLink } from "@ionic/react";
import { withTranslation } from "react-i18next";
import ApiService from "../../services/ApiService";
import IconButton from "../Button/Icon/IconButton";
import { ProfileInputWrap } from "./index";

interface SponsorsProps {
  sponsors: Sponsor[];
}

const profileFields = [
  { name: "name", type: "text", rules: ["required"], attr: { placeholder: "Sponsor's Name" } },
  { name: "website", type: "url", attr: { placeholder: "Sponsor's website" } },
];

class Sponsors extends React.Component<SponsorsProps | any, any> {
  constructor(props: Readonly<any> | any) {
    super(props);
    this.state = { sponsors: [] };
  }

  render() {
    const { disabled, t } = this.props;
    const { sponsors = [] } = this.state;

    return (
      <>
        {disabled ? (
          <InputFactory placeholder={sponsors.map((sponsor: Sponsor) => sponsor.name).join(", ") || "―"} disabled={true} />
        ) : (
          sponsors.map((sponsor: Sponsor | any, sponsorKey: number) => (
            <div key={sponsorKey} className={!disabled ? "sponsor-input__wrap" : ""}>
              {profileFields.map((field, key) => (
                <ProfileInputWrap key={key} type={field.type} className="ion-margin-vertical">
                  <InputFactory {...field} value={sponsor[field.name]} disabled={disabled} className="input__input" onIonChange={(e: any) => this.onChange(e, sponsorKey)} />
                  {this.renderInputError(sponsorKey, field, this.props.error)}
                </ProfileInputWrap>
              ))}
              <IconButton icon={faTrashAlt} tooltip={t("remove")} align="left" type="solid" color="danger" onClick={() => this.removeSponsor(sponsorKey, sponsor)} />
            </div>
          ))
        )}

        {!disabled && (
          <IonRouterLink className="sponsor-input__button-add" onClick={() => this.addNewSponsor()}>
            <FontAwesomeIcon icon={["fas", "plus"]} /> {t("addAnotherSponsor")}
          </IonRouterLink>
        )}
      </>
    );
  }

  renderInputError(sponsorKey: number, field: any, errors: any) {
    return (
      errors &&
      errors[sponsorKey]?.[field.name] && (
        <IonNote className="input__error" color="danger">
          {errors[sponsorKey][field.name]}
        </IonNote>
      )
    );
  }

  componentDidMount() {
    this.setState({ sponsors: this.props.value ? this.props.value : [] });
  }

  onChange = (e: any, key: number) => {
    const { sponsors } = this.state;

    sponsors[key][e.target.name] = e.detail.value;

    this.setState({ sponsors }, () => {
      this.props.onIonChange?.(
        new CustomEvent("ionChange", {
          detail: {
            name: this.props.name,
            value: sponsors,
          },
        }),
      );
    });
  };

  addNewSponsor = () => {
    this.setState({ sponsors: [...this.state.sponsors, { name: null, website: null }] });
  };

  removeSponsor = async (key: number, sponsor: Sponsor | any) => {
    const { sponsors } = this.state;

    let error: boolean = false;
    if (sponsor.hasOwnProperty("id")) {
      const user = await this.props.user;
      await ApiService.post(`users/${user.id}/athlete/sponsors/remove/${sponsor.id}`, {}).catch((err) => {
        alert(err.message);
        // error = true; // todo: uncomment once API returning json
      });
    }

    if (!error) {
      sponsors.splice(key, 1);
      this.setState({ sponsors }, () => {
        this.props.onIonChange?.(
          new CustomEvent("ionChange", {
            detail: {
              name: this.props.name,
              value: sponsors,
            },
          }),
        );
      });
    }
  };
}

export default withTranslation()(Sponsors);
